
import { toast } from 'sonner';
import { AnalysisHistory } from './types/analysisTypes';

// Tarama geçmişini localStorage'dan alır
export const getScanHistory = (): AnalysisHistory[] => {
  try {
    const localHistory = localStorage.getItem('scan_history');
    if (localHistory) {
      return JSON.parse(localHistory);
    }
  } catch (error) {
    console.error('Tarama geçmişi yüklenirken hata oluştu', error);
  }
  return [];
};

// Yeni tarama kaydını geçmişe ekler ve localStorage'a kaydeder
export const addScanToHistory = (domain: string, urlCount: number): AnalysisHistory[] => {
  try {
    const history = getScanHistory();
    
    // Eğer aynı domain zaten varsa, onu kaldır (en üste yenisini ekleyeceğiz)
    const filteredHistory = history.filter(item => item.domain !== domain);
    
    // Yeni tarama bilgisini ekle
    const newScan: AnalysisHistory = {
      domain,
      date: new Date().toISOString(),
      urlCount
    };
    
    // Yeni taramayı listenin başına ekle ve son 50 tarama kaydını tut
    const updatedHistory = [newScan, ...filteredHistory].slice(0, 50);
    
    // LocalStorage'a kaydet
    localStorage.setItem('scan_history', JSON.stringify(updatedHistory));
    
    return updatedHistory;
  } catch (error) {
    console.error('Tarama geçmişi kaydedilirken hata oluştu', error);
    return getScanHistory();
  }
};

export const getScanHistoryFromFile = async () => {
  try {
    // First try to load from localStorage
    const localHistory = localStorage.getItem('scan_history');
    if (localHistory) {
      return JSON.parse(localHistory);
    }
    
    // If not in localStorage, try to load from file
    const response = await fetch('/scan_history.txt');
    if (response.ok) {
      const content = await response.text();
      try {
        const data = JSON.parse(content || '[]');
        // Save to localStorage for future use
        localStorage.setItem('scan_history', JSON.stringify(data));
        return data;
      } catch (e) {
        console.error('Invalid JSON in scan_history.txt', e);
        return [];
      }
    }
  } catch (error) {
    console.error('Error loading scan history', error);
  }
  return [];
};

export const saveScanHistoryToFile = async (history: AnalysisHistory[]) => {
  try {
    const content = JSON.stringify(history, null, 2);
    
    // Save to localStorage
    localStorage.setItem('scan_history', content);
    
    // Save to file
    const response = await fetch('/scan_history.txt', {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: content
    });
    
    if (!response.ok) {
      throw new Error(`Error writing to scan_history.txt: ${response.statusText}`);
    }
    
    toast.success('Tarama geçmişi güncellendi');
  } catch (error) {
    console.error('Error saving scan history', error);
    toast.error('Tarama geçmişi güncellenemedi');
  }
};
